type Listener = (online: boolean) => void;

const listeners = new Set<Listener>();
let sisteStatus = true;

export function startNettstatusLytter(): void {
  if (typeof window === 'undefined') return;
  sisteStatus = erOnline();
  window.addEventListener('online', () => {
    sisteStatus = true;
    emit(true);
  });
  window.addEventListener('offline', () => {
    sisteStatus = false;
    emit(false);
  });
}

export function erOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}

export function abonnerNettstatus(cb: Listener): () => void {
  listeners.add(cb);
  cb(sisteStatus);
  return () => listeners.delete(cb);
}

function emit(online: boolean): void {
  listeners.forEach((cb) => cb(online));
}
